<template>
  <div>
    <div style="overflow-x: auto" v-if="showSlotsResult">
      <div
        class="custom-div"
      >
        <app-heading
          :text="'NBN Available Appointment Slots'"
          :heading="'main'"
        ></app-heading>
        <div ref="result" class="center">
          <div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Place:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.place.id }}
              </p>
            </div>

            <v-divider class="mt-6 mb-4"></v-divider>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Work Zone
              </p>
            </div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Primary Access Technology:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.workZone.primaryAccessTechnology }}
              </p>
            </div>
            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Serviceability Class:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.workZone.serviceabilityClass }}
              </p>
            </div>
            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Csa ID:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.workZone.csaID }}
              </p>
            </div>
            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Region:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.workZone.region }}
              </p>
            </div>

            <v-divider class="mt-6 mb-4"></v-divider>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Available TimeSlot
              </p>
            </div>

            <div v-for="(item, index) in result.data.availableTimeSlot" :key="index">
              <v-divider class="mt-6 mb-4"></v-divider>
              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Appointment SlotType
                </p>
                <p class="custom-p">
                  <span v-html="tier2"></span>{{ item.appointmentSlotType }}
                </p>
              </div>

              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Valid Start DateTime
                </p>
                <p class="custom-p">
                  <span v-html="tier2"></span>{{ item.validFor.startDateTime }}
                </p>
              </div>

              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Valid End DateTime
                </p>
                <p class="custom-p">
                  <span v-html="tier2"></span>{{ item.validFor.endDateTime }}
                </p>
              </div>

              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Within TimeWindow
                </p>
                <p class="custom-p">
                  <span v-html="tier2"></span>{{ item.withinTimeWindow }}
                </p>
              </div>

              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Appointment LeadTime
                </p>
                <p class="custom-p">
                  <span v-html="tier2"></span>{{ item.appointmentLeadTime }}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "available-slots-results",
  data: () => ({
    showSlotsResult: false,
    tier1: "&nbsp;",
    tier2: "&nbsp;&nbsp;&nbsp;",
    result:{}
  }),
  methods: {
    addClass() {
      return "first-sq";
    },
  },
}
</script>

<style scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

.center {
  margin: auto;
  width: 50%;
  border: 3px solid green;
  padding: 10px;
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}
</style>
